
    import './styles.scoped.css';
    export default {
  "body": "awsui_body_1i6l7_dceuf_5",
  "body-grid": "awsui_body-grid_1i6l7_dceuf_9"
};
  